import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  Typography,
} from "@material-ui/core";
import {
  TextValidator,
  ValidatorForm,
  SelectValidator,
} from "react-material-ui-form-validator";
import moment from "moment";
import "moment/locale/es";
import React from "react";
import { useSelector } from "react-redux";
import { useForm } from "../../../hooks/useForm";
import { CboLocalidades } from "../../cbos/CboLocalidades";
import { CboProvincias } from "../../cbos/CboProvincias";
import { CARTILLAS, RANKINGS_CARTILLA, TIPO_EFECTORES } from "../../../utils/constants";
import Select from "react-select";
import { SUBTIPO_EFECTORES } from "../../../utils/constants";

export const CartillaForm = (props) => {
  moment.locale("es");
  const { formData } = props

  const { items: localidadesArray } = useSelector((state) => state.localidades);

  const { items: especialidades } = useSelector((state) => state.especialidades);
  const { dataContrato } = useSelector((state) => state.contrataciones);
  const {
    rubros,
    zonas,
    centrosMedicos,
    rankingsCartilla,
    cartilla,
    planes,
  } = useSelector((state) => state.contratacionesCartilla);

  const contratoProfesionalCentroPropio = dataContrato.idSubTipoEfector === SUBTIPO_EFECTORES.PROFESIONALES_CENTROS_PROPIOS
  let nuevoCartillaPrestador = {
    idCartillaPrestadores: null,
    atiendeCentroPropio: contratoProfesionalCentroPropio,
    publica: true,
    idRubro:
      dataContrato.idSubTipoEfector === SUBTIPO_EFECTORES.FARMACIA
        ? rubros.filter((rubro) => rubro.descripcion === "FARMACIAS")[0]
          ?.idRubro
        : dataContrato.idSubTipoEfector ===
          SUBTIPO_EFECTORES.PROFESIONALES_CENTROS_PROPIOS ||
          dataContrato.idSubTipoEfector ===
          SUBTIPO_EFECTORES.PROFESIONALES_CENTROS_AJENOS
          ? rubros.filter(
            (rubro) => rubro.descripcion === "ATENCIÓN AMBULATORIA"
          )[0]?.idRubro
          : "",
    idRanking: dataContrato.idSubTipoEfector === SUBTIPO_EFECTORES.PROFESIONALES_CENTROS_PROPIOS ? RANKINGS_CARTILLA.CM_PROPIO : "",
    idCentroMedico: "",
    cartillaPrestadoresDomicilio: {
      domicilio: "",
      cp: "",
      idLocalidad: "",
      idProvincia: "",
      idZona: "",
      idCartilla: dataContrato.idTipoEfector === TIPO_EFECTORES.INTEGRACION ? CARTILLAS.ADICCIONES_DISCAPACIDAD : "",
      telefono: ""
    },
    cartillaPrestadoresMatriculas: [],
    cartillaPrestadoresEspecialidades: [],
    cartillaPrestadoresPlanesContratos: planes.map(e => e.id),
  };

  const [
    formValues,
    handleInputChange,
    ,
    setearValor,
    ,
    ,
    ,
    ,
    setearVariosValores,
    setearVariosValoresHijos,
  ] = useForm(formData ? {...formData, atiendeCentroPropio: contratoProfesionalCentroPropio || formData.atiendeCentroPropio} : nuevoCartillaPrestador);

  const {
    atiendeCentroPropio,
    publica,
    idRubro,
    idRanking,
    idCentroMedico,
    cartillaPrestadoresDomicilio: {
      domicilio = "",
      cp = "",
      idLocalidad = "",
      idProvincia = "",
      idZona = "",
      idCartilla = "",
      telefono = ""
    },
    cartillaPrestadoresEspecialidades,
    cartillaPrestadoresPlanesContratos,
  } = formValues;

  const handleLocalidadChange = (e) => {
    const localidadEncontrada = localidadesArray.find(
      (loc) => parseInt(loc?.id_localidad) === parseInt(e.target.value)
    );
    const zonaEncontrada = zonas.find(
      (zona) =>
        parseInt(zona.idProvincia) ===
        parseInt(localidadEncontrada?.id_provincia)
    );
    setearVariosValoresHijos("cartillaPrestadoresDomicilio", {
      idLocalidad: localidadEncontrada?.id_localidad,
      idProvincia: localidadEncontrada?.id_provincia,
      idZona: zonaEncontrada?.id,
      idCartilla: zonaEncontrada?.idCartilla,
    });
  };

  const onChangeEspecialidadesHandler = (e) => {
    setearValor(
      "cartillaPrestadoresEspecialidades",
      e.map((e) => e.value)
    );
  };

  const onChangePlanesHandler = (e) => {
    setearValor(
      "cartillaPrestadoresPlanesContratos",
      e.map((e) => e.value)
    );
  };

  const onChangeCentrosMedicosHandler = (e) => {
    const centroMedicoEncontrado = centrosMedicos.find(
      (centroMedico) =>
        parseInt(centroMedico.idCentroMedico) === parseInt(e.target.value)
    );
    const localidadEncontrada = localidadesArray.find(
      (loc) => parseInt(loc?.id_localidad) === parseInt(centroMedicoEncontrado?.idLocalidad)
    );
    const zonaEncontrada = zonas.find(
      (zona) =>
        parseInt(zona.idProvincia) ===
        parseInt(localidadEncontrada?.id_provincia)
    );

    setearVariosValores({
      idCentroMedico: e.target.value,
      cartillaPrestadoresDomicilio: {
        domicilio: centroMedicoEncontrado
          ? centroMedicoEncontrado.direccion
          : "",
        cp: centroMedicoEncontrado ? centroMedicoEncontrado.cp : "",
        idLocalidad: localidadEncontrada
          ? localidadEncontrada.id_localidad
          : "",
        idProvincia: localidadEncontrada
          ? localidadEncontrada.id_provincia
          : "",
        idZona: zonaEncontrada ? zonaEncontrada.id : "",
        idCartilla: zonaEncontrada ? zonaEncontrada.idCartilla : "",
        telefono: centroMedicoEncontrado ? centroMedicoEncontrado.telefono : ""
      },
    });
  };

  const handleChangeCheckbox = (e) => {
    if (!e.target.checked) {
      setearVariosValores({
        atiendeCentroPropio: e.target.checked,
        idCentroMedico: ""
      })
    } else {
      setearValor("atiendeCentroPropio", e.target.checked);
    }
  };

  const handleSave = (e) => {
    e.preventDefault();

    const datosFormateados = {
      ...formValues,
      especialidades: cartillaPrestadoresEspecialidades,
      planes: cartillaPrestadoresPlanesContratos,
      domicilio,
      cp,
      idLocalidad,
      idProvincia,
      idZona,
      idCartilla,
      telefono
    };
    props.handleSubmit(datosFormateados);
  };

  return (
    <ValidatorForm onSubmit={handleSave}>
      <Grid container spacing={1} justify="space-between">
        <Grid
          item
        >
          <FormControlLabel
            label="¿Publica en cartilla?"
            control={
              <Checkbox
                name="publica"
                checked={publica}
                onChange={() => setearValor("publica", !publica)}
              />
            }
          />
        </Grid>
        <Grid
          item
        >
          <FormControlLabel
            label="¿Atiende en Centro Médico Propio?"
            control={
              <Checkbox
                name="atiendeCentroPropio"
                checked={atiendeCentroPropio}
                onChange={contratoProfesionalCentroPropio ? () => { } : handleChangeCheckbox}
                disabled={contratoProfesionalCentroPropio}
              />
            }
          />
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        {atiendeCentroPropio && (
          <Grid item xs={12}>
            <SelectValidator
              fullWidth
              margin="normal"
              label="Centro Medico"
              name="idCentroMedico"
              value={idCentroMedico}
              onChange={onChangeCentrosMedicosHandler}
              validators={atiendeCentroPropio && ["required"]}
              errorMessages={atiendeCentroPropio && ["Seleccione un Centro Medico"]}
            >
              {
                centrosMedicos.filter(x => x.fechaBaja === null).map((centroMedico) => (
                  <MenuItem
                    key={centroMedico.idCentroMedico}
                    value={centroMedico.idCentroMedico}
                  >
                    {centroMedico.descripcionCentro}
                  </MenuItem>
                ))
              }
            </SelectValidator>
          </Grid>
        )}
        <Grid item xs={6} style={{ marginTop: "10px" }}>
          <Typography variant="button">Especialidades</Typography>
          <Select
            onChange={onChangeEspecialidadesHandler}
            value={
              cartillaPrestadoresEspecialidades?.map((item) => {
                const especialidad = especialidades.find(
                  (e) => e.idEspecialidades === item
                );
                return especialidad
                  ? {
                    value: especialidad.idEspecialidades,
                    label: especialidad.descripcionEspecialidades,
                  }
                  : undefined;
              }) ?? []
            }
            isMulti
            name="colors"
            options={
              especialidades
                .filter(item => dataContrato.efectorFacturacionEspecialidades.includes(item.idEspecialidades))
                .map((item) => ({
                  value: item.idEspecialidades,
                  label: item.descripcionEspecialidades
                }))
            }
            placeholder="Seleccione Especialidades..."
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            menuPosition="fixed"
          />
        </Grid>
        <Grid item xs={6} style={{ marginTop: "10px" }}>
          <Typography variant="button">Planes</Typography>
          <Select
            onChange={onChangePlanesHandler}
            value={
              cartillaPrestadoresPlanesContratos?.map((item) => {
                const plan = planes.find((e) => e.id === item);
                return plan
                  ? {
                    value: plan.id,
                    label: plan.descripcion,
                  }
                  : undefined;
              }) ?? []
            }
            isMulti
            name="colors"
            options={planes.map((plan) => ({
              value: plan.id,
              label: plan.descripcion,
            }))}
            placeholder="Seleccione Planes..."
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            menuPosition="fixed"
          />
        </Grid>

        <Grid item xs={5}>
          <TextValidator
            fullWidth
            margin="normal"
            label="Teléfono"
            name="cartillaPrestadoresDomicilio.telefono"
            value={telefono}
            disabled={atiendeCentroPropio}
            onChange={handleInputChange}
          // validators={[
          //   "required",
          //   "isNumber"
          // ]}
          // type="number"
          // errorMessages={[
          //   "El teléfono es requerido",
          //   "Solo numeros"
          // ]}
          />
        </Grid>
        <Grid item xs={5}>
          <TextValidator
            fullWidth
            margin="normal"
            label="Domicilio"
            name="cartillaPrestadoresDomicilio.domicilio"
            value={domicilio}
            onChange={handleInputChange}
            disabled={atiendeCentroPropio}
            validators={["required"]}
            errorMessages={["El domicilio es requerido"]}
          />
        </Grid>
        <Grid item xs={2}>
          <TextValidator
            fullWidth
            margin="normal"
            label="CP"
            name="cartillaPrestadoresDomicilio.cp"
            value={cp}
            onChange={handleInputChange}
            disabled={atiendeCentroPropio}
            maxLength="4"
            validators={[
              "required",
              "isNumber",
              "maxNumber:9999",
              "minNumber:999",
            ]}
            errorMessages={[
              "CP requerido",
              "Sólo números",
              "Verifique Cod.Postal",
              "Verifique Cod.Postal",
            ]}
          />
        </Grid>
        <Grid item xs={4}>
          <CboLocalidades
            margin="normal"
            name="cartillaPrestadoresDomicilio.idLocalidad"
            cp={cp ? cp : 0}
            valor={idLocalidad}
            manejadorInputChange={handleLocalidadChange}
            disabled={atiendeCentroPropio}
          />
        </Grid>
        <Grid item xs={4}>
          <CboProvincias
            margin="normal"
            name="cartillaPrestadoresDomicilio.idProvincia"
            valor={idProvincia}
            manejadorInputChange={handleInputChange}
            disabled={atiendeCentroPropio}
          />
        </Grid>
        <Grid item xs={4}>
          <SelectValidator
            fullWidth
            margin="normal"
            label="Zona"
            name="cartillaPrestadoresDomicilio.idZona"
            value={idZona}
            onChange={handleInputChange}
            disabled={atiendeCentroPropio}
            validators={["required"]}
            errorMessages={["Seleccione una Zona"]}
          >
            {zonas.map((zona) => (
              <MenuItem key={zona.id} value={zona.id}>
                {zona.descripcion}
              </MenuItem>
            ))}
          </SelectValidator>
        </Grid>
        <Grid item xs={4}>
          <SelectValidator
            fullWidth
            margin="normal"
            label="Rubro"
            name="idRubro"
            value={idRubro}
            onChange={handleInputChange}
            validators={["required"]}
            errorMessages={["Seleccione un Rubro"]}
          >
            {rubros.map((rubro) => (
              <MenuItem key={rubro.idRubro} value={rubro.idRubro}>
                {rubro.descripcion}
              </MenuItem>
            ))}
          </SelectValidator>
        </Grid>
        <Grid item xs={4}>
          <SelectValidator
            fullWidth
            margin="normal"
            label="Cartilla"
            name="cartillaPrestadoresDomicilio.idCartilla"
            value={idCartilla}
            onChange={handleInputChange}
            disabled={atiendeCentroPropio}
            validators={["required"]}
            errorMessages={["Seleccione una Cartilla"]}
          >
            {cartilla.map((car) => (
              <MenuItem key={car.idCartilla} value={car.idCartilla}>
                {car.descripcionCartilla}
              </MenuItem>
            ))}
          </SelectValidator>
        </Grid>
        <Grid item xs={4}>
          <SelectValidator
            fullWidth
            margin="normal"
            label="Ranking | Categorias"
            name="idRanking"
            value={idRanking}
            onChange={handleInputChange}
            validators={["required"]}
            errorMessages={["Seleccione un Ranking|Cartilla"]}
            disabled={dataContrato.idSubTipoEfector === SUBTIPO_EFECTORES.PROFESIONALES_CENTROS_PROPIOS}
          >
            {rankingsCartilla.map((rank) => (
              <MenuItem
                key={rank.idRankingCartilla}
                value={rank.idRankingCartilla}
              >
                {rank.descripcion}
              </MenuItem>
            ))}
          </SelectValidator>
        </Grid>
      </Grid>
      <div style={{ textAlign: "right", marginTop: "2rem" }}>
        <Button type="submit" color="primary">
          Aceptar
        </Button>
        <Button onClick={props.handleCloseModal} type="button" color="primary">
          Cancelar
        </Button>
      </div>
    </ValidatorForm>
  );
};
